import { render, staticRenderFns } from "./CreateGroupModal.vue?vue&type=template&id=abef1f9e&scoped=true"
import script from "./CreateGroupModal.vue?vue&type=script&lang=js"
export * from "./CreateGroupModal.vue?vue&type=script&lang=js"
import style0 from "./CreateGroupModal.vue?vue&type=style&index=0&id=abef1f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abef1f9e",
  null
  
)

export default component.exports